import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { View, FlatList, StyleSheet, ActivityIndicator } from 'react-native'
import { bindingTypes } from '@adalo/constants'

import { getVisible } from '../../utils/visibility'
import { getObjectBinding } from '../../utils/dependencies'
import { indexOf } from '../../utils/arrays'
import { isListObject } from '../../utils/lists'
import { MultipleObjectRenderer, ObjectRenderer } from '../ObjectRenderer'

const EMPTY_ARRAY = []

class ListBody extends Component {
  getWrapper = () => {
    let { body } = this.props
    let wrapper = body[0]

    return wrapper
  }

  getObjects = () => {
    let wrapper = this.getWrapper()

    if (!wrapper || !wrapper.children) {
      return []
    }

    return wrapper.children
  }

  getBottomPadding = () => {
    let wrapper = this.getWrapper()
    return wrapper.layout.paddingBottom
  }

  getListIndex = () => {
    let objects = this.getObjects()

    return indexOf(objects, obj => isListObject(obj))
  }

  getList = () => {
    return this.getObjects()[this.getListIndex()]
  }

  getHeader = () => {
    let index = this.getListIndex()

    return this.getObjects().slice(0, index)
  }

  getFooter = () => {
    let index = this.getListIndex() + 1

    return this.getObjects().slice(index)
  }

  getChildProps = () => {
    let { component, active, topScreen } = this.props

    return { component, active, topScreen }
  }

  getTopPadding = () => {
    let {
      style: { paddingTop },
    } = this.props
    let firstObject = this.getObjects()[0]

    return paddingTop + firstObject.layout.marginTop
  }

  getItem = (list, firstItem = false) => {
    let marginTop = 0

    if (!firstItem) {
      marginTop = list.attributes.rowMargin
    }

    return {
      ...list,
      layout: {
        ...list.layout,
        marginTop,
      },
      type: 'listItem',
    }
  }

  renderHeader = () => {
    let { style } = this.props
    let { paddingTop } = style
    let list = this.getList()
    let headerObjects = this.getHeader()

    let styles = {
      paddingTop,
      marginBottom: list.layout.marginTop,
    }

    return (
      <View style={styles}>
        <MultipleObjectRenderer
          {...this.getChildProps()}
          objects={headerObjects}
        />
      </View>
    )
  }

  renderFooter = () => {
    let { style, bindingData, loading } = this.props
    let { paddingBottom } = style
    let list = this.getList()
    let footerObjects = this.getFooter()

    let footerStyles = {
      paddingBottom,
      paddingTop: list.layout.marginBottom,
    }

    return (
      <View>
        {loading || !bindingData ? (
          <View style={styles.loader}>
            <ActivityIndicator />
          </View>
        ) : null}
        <View style={footerStyles}>
          <MultipleObjectRenderer
            {...this.getChildProps()}
            objects={footerObjects}
          />
        </View>
      </View>
    )
  }

  renderItem = ({ item, separators, index }) => {
    let list = this.getList()
    let firstItem = index === 0

    if (item.key === 'spacer') {
      return this.renderSpacer()
    }

    return (
      <ObjectRenderer
        visible
        {...this.getChildProps()}
        object={this.getItem(list, firstItem)}
        bindingData={[item]}
      />
    )
  }

  renderSpacer() {
    let paddingBottom = this.getBottomPadding()

    return <View style={{ height: paddingBottom }} />
  }

  keyExtractor = itm => {
    return String(itm.id)
  }

  getData = () => {
    let { bindingData } = this.props
    let list = this.getList()
    let binding = list && list.dataBinding
    let data

    if (bindingData && binding && binding.bindingType === bindingTypes.LIST) {
      data = bindingData || []
    }

    return data
  }

  handleResize = (width, height) => {
    let { component } = this.props

    if (height) {
      this._innerHeight = height
    }

    if (this._scrollView && component.reverseScroll) {
      window.setTimeout(() => {
        this._scrollView.scrollToEnd({ animated: true })
      }, 10)
    }
  }

  scrollViewRef = el => {
    this._scrollView = el
  }

  render() {
    let { onEndReached, onRefresh, refreshing, visible } = this.props

    let data = this.getData() || []
    data = data.concat([{ key: 'spacer' }])

    if (!visible) {
      data = EMPTY_ARRAY
    }

    return (
      <FlatList
        ref={this.scrollViewRef}
        data={data}
        renderItem={this.renderItem}
        ListHeaderComponent={this.renderHeader}
        ListFooterComponent={this.renderFooter}
        keyExtractor={this.keyExtractor}
        onEndReached={onEndReached}
        onRefresh={onRefresh}
        refreshing={refreshing}
        progressViewOffset={this.getTopPadding()}
        showsVerticalScrollIndicator={false}
        onContentSizeChange={this.handleResize}
      />
    )
  }
}

const mapStateToProps = (
  state,
  { body, getParams, getBinding, getBindingsList, getApp }
) => {
  const wrapper = body[0]

  if (!wrapper || !wrapper.children) {
    return {}
  }

  const list = wrapper.children.filter(c => isListObject(c))[0]

  if (!list) {
    return {}
  }

  const bindingData = getObjectBinding(state, list, {
    getParams,
    getBinding,
    getBindingsList,
    getApp,
  })

  const visible = getVisible(state, list, {
    getParams,
    getBinding,
    getBindingsList,
    getApp,
  })

  return { bindingData, visible }
}

const ConnectedListBody = connect(mapStateToProps)(ListBody)

export default class WrappedListBody extends Component {
  static contextTypes = {
    getBinding: PropTypes.func,
    getBindingsList: PropTypes.func,
    getParams: PropTypes.func,
    getApp: PropTypes.func,
  }

  render() {
    return <ConnectedListBody {...this.props} {...this.context} />
  }
}

const styles = StyleSheet.create({
  loader: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
})
